import React, { useState } from 'react';
import './ContainerOrgInfo.css';
import Tabs from '../Tabs/Tabs';
import EditorContainerProfile from '../EditorContainerProfile/EditorContainerProfile';
import { categoriesFieldsMyOrg } from '../../constants/categoriesField';
import FormButtonsOrg from '../FormButtonsOrg/FormButtonsOrg';
import GeneralInfoOrg from '../GeneralInfoOrg/GeneralInfoOrg';
import GeneralInfoButtons from '../GeneralInfoButtons/GeneralInfoButtons';
import SubmitButton from '../SubmitButton/SubmitButton';
import { useAuth } from '../../Context/AuthContext';
import IntegrationModal from '../IntegrationModal/IntegrationModal';
import { createPortal } from 'react-dom';
const ContainerOrgInfo = ({
  handleChangeFormData,
  formData,
  isFormValid,
  isFormChanged,
  saveOrganisationData,
  handleCancel,
  handleButtonDelete,
  handleImageChange,
  formDataGeneralInformation,
  handleChangeGeneralInformation,
  isFormGeneralInfoChanged,
  handleGeneralInfoCancel,
  saveOrganisationDataGeneralInfo,
  isLoadingImage,
  isLoadingFormData,
  isLoadingCancelEdit,
  isLoadingRemove,
  isAnswer,
  selectedItemId,
}) => {
  const [tabs, setTabs] = useState([
    { id: 'contacts', value: 'Контактная информация', active: true },
    { id: 'general', value: 'Общая информация', active: false },
  ]);
  const [selectedTab, setSelectedTab] = useState(
    tabs.find((tab) => tab.active)?.id || 'contacts'
  );

  const handleTabSelected = (e) => {
    const clickedId = e.currentTarget.dataset.id;
    setTabs((prev) =>
      prev.map((item) => ({
        ...item,
        active: item.id === clickedId,
      }))
    );
    setSelectedTab(clickedId);
  };

  const { is_admin } = useAuth();
  const [isVisible, setIsVisible] = useState(false);

  const onOpenIntModal = () => {
    setIsVisible(true);
  };
  const onCloseIntModal = () => {
    setIsVisible(false);
  };
  return (
    <div className='container-org-info'>
      <h2 className='container-org-info__header'>
        <Tabs handleTabSelected={handleTabSelected} tabs={tabs} />
      </h2>

      {selectedTab === 'contacts' && (
        <div className='container-org-info__contacts'>
          <EditorContainerProfile
            canEdit={isAnswer}
            formData={formData}
            categories={categoriesFieldsMyOrg}
            handleChangeFormData={handleChangeFormData}
          />
          {isAnswer && (
            <FormButtonsOrg
              isFormChanged={isFormChanged}
              isFormValid={isFormValid}
              isLoadingFormData={isLoadingFormData}
              isLoadingRemove={isLoadingRemove}
              onSave={saveOrganisationData}
              onCancel={handleCancel}
              onDelete={handleButtonDelete}
              onSync={onOpenIntModal}
              deleteDisabled={false}
            />
          )}

          {createPortal(
            <IntegrationModal
              selectedItemId={selectedItemId}
              isVisible={isVisible}
              onClose={onCloseIntModal}
            />,
            document.body
          )}
        </div>
      )}
      {selectedTab === 'general' && (
        <div className='container-org-info__general'>
          <GeneralInfoOrg
            canEdit={isAnswer}
            handleImageChange={handleImageChange}
            formDataGeneralInformation={formDataGeneralInformation}
            handleChangeGeneralInformation={handleChangeGeneralInformation}
            isLoadingImage={isLoadingImage}
          />
          {isAnswer && (
            <GeneralInfoButtons
              isLoadingFormData={isLoadingFormData}
              isFormChanged={isFormGeneralInfoChanged}
              isFormValid={isFormValid}
              onSave={saveOrganisationDataGeneralInfo}
              onCancel={handleGeneralInfoCancel}
              isLoadingCancelEdit={isLoadingCancelEdit}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ContainerOrgInfo;
